import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs } from "@/components/landing/data";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="section-shell grid gap-12 py-24 sm:py-32 lg:grid-cols-[0.75fr_1.25fr]">
      <div>
        <p data-testid="faq-eyebrow" className="eyebrow">FAQ / direct answers</p>
        <h2 data-testid="faq-heading" className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-[-0.05em] text-white sm:text-6xl">Before we talk.</h2>
      </div>
      <Accordion type="single" collapsible className="glass-panel rounded-[1.8rem] px-6 sm:px-8" data-testid="faq-accordion">
        {faqs.map(([question, answer], index) => (
          <AccordionItem key={question} value={`item-${index}`} data-testid={`faq-accordion-item-${index + 1}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-question-${index + 1}`} className="py-6 text-left font-display text-lg font-bold uppercase tracking-[-0.02em] text-white hover:text-cyan-200 hover:no-underline sm:text-xl">
              {question}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${index + 1}`} className="pb-6 text-sm leading-relaxed text-slate-400 sm:text-base">
              {answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
